import { Record } from 'immutable';

const InvoiceHistoryVendorRecord = Record({
  chain: null,
  brand: null,
  pid: null
});

export class InvoiceHistoryVendor extends InvoiceHistoryVendorRecord {
  chain: string;
  brand: string;
  pid: string;
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/invoice-history-vendor.ts